import LinearGradient from './linear-gradient';
export default LinearGradient;
